module.exports = __webpack_public_path__ + "static/media/日语朗读？？傲娇台词版五十音图.9ba5916d.png";